import { render } from "./IconMagnifyingGlass.vue?vue&type=template&id=42ff8e8d"
import script from "./IconMagnifyingGlass.vue?vue&type=script&lang=js"
export * from "./IconMagnifyingGlass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__